<template>
  <div>
    <v-list-item three-line>
      <v-list-item-avatar>
        <v-icon class="primary white--text">mdi-store</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="expanded">{{itemTitle}}</v-list-item-title>
        <v-list-item-subtitle class="expanded">Адрес: {{itemAddress}}</v-list-item-subtitle>
        <v-list-item-subtitle
            v-html="item.note"
            class="expanded html-subtitle"
        ></v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider v-if="needDivider"></v-divider>
  </div>
</template>

<script>
import {getPickupPointTitle, replaceToBr} from '@/services/utils'

export default {
  name: 'BuyoutPickupPointListItem',
  computed: {
    itemTitle () {
      return getPickupPointTitle(this.item)
    },
    itemAddress () {
      return replaceToBr(this.item.address)
    },
    itemNote () {
      return replaceToBr(this.item.note)
    },
  },
  props: {
    item: {
      required: true,
      type: Object
    },
    needDivider: {
      required: true,
      type: Boolean
    }
  }
}
</script>

<style scoped>

</style>